// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"894":"17071edc","1092":"17071edc","5448":"5f2105dd"}[chunkId] + ".chunk.css";
};